import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Slider from "../Page-section/Home/Slider";
import Homecantainer from "../Page-section/Home/Homecantainer";
import Footer from "../components/Footer";
import Latestinsight from "../Page-section/Home/Latestinsights";
import Aboutbriefly from "../Page-section/Home/Aboutbriefly";
import Contactpage from "../components/Contactpage";
import Faq from "../Page-section/Faq";
import WorkingProcess from "../Page-section/Home/WorkingProcess";
import AutoPopupForm from "../components/AutoPopupForm";
import { useSEO } from "../hooks/useSEO";
import TechnologySlider from "../Page-section/Home/TechnologySlider";

function Home() {
  useSEO({
    title:
      "Digital Marketing, Web Development & AI Automation Agency in India ",
    description:
      "Grow your business with expert Digital Marketing, Web Development, SEO, and AI Automation services. We create high-converting websites, marketing strategies.",
    canonical: "https://empowerweb.in/",
    ogTitle: "Empower Web - AI-Driven Digital Marketing & Business Development",
    ogDescription:
      "Transform your business with AI-driven automation, expert SEO, and web development services. Increase sales with cutting-edge digital marketing solutions in Delhi NCR.",
    keywords:
      "empowerweb, empower web, AI-driven digital marketing, business development, SEO services Noida, web development Delhi NCR, marketing automation, increase sales, lead generation, AI automation, digital transformation, Noida agency",
  });
  
  return (
    <div className="home-page">
      <Header />
      <Navbar />
      <main id="main-content">
        <Slider />
        <Aboutbriefly />
        <Homecantainer />
        <TechnologySlider />
        <Latestinsight />
        <WorkingProcess />
        <Faq />
        <Contactpage />
      </main>
      <Footer />
      <AutoPopupForm />
    </div>
  );
}
export default Home;
